import React from 'react';

export default function SubmitButton({
  label,
  onClick,
  isSubmitting,
  isSubmittingText,
  className,
  disabled = false,
  type,
}) {
  return (
    <button type={type || 'submit'} disabled={disabled || isSubmitting} onClick={onClick} className={className ? className : "bg-sky-700 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-sky-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 disabled:opacity-50 items-center"}>
      {
        isSubmitting && (
          <svg className="animate-spin ml-1 mr-3 h-5 w-5 text-white" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        )
      }
      {isSubmitting ? isSubmittingText : label}
    </button>
  );
};